import React, { useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import "./ButtonDetails.css";
import acImage from "../assets/sqaure.jpeg";
import rectImage from "../assets/rect.png";
import onec from "../assets/1c.jpeg";
import fourc from "../assets/4c.jpeg";
import ducttype from "../assets/ducttype.jpeg";
import recommand1 from "../assets/recommand1.jpeg";
import recommand2 from "../assets/recommand2.jpeg";
import degree from "../assets/degree.jpeg";
import mall from "../assets/mall.jpeg";
import hospital from "../assets/hospital.jpeg";
import restaurant from "../assets/Restaurant.jpeg";
import threater from "../assets/threater.jpeg";
import hotel from "../assets/hotel.jpeg";
import {useNavigate } from "react-router-dom";
import oneYearSyllabus from "../assets/../assets/SkyBreezeACSolutionCourse-Syllabus.pdf";
import threeMonthSyllabus from "../assets/SkyBreezeACSolutionInternship-Syllabus.pdf";

export default function ButtonDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const userType = location.state?.userType || params.userType;

  const [customerPage, setCustomerPage] = useState("menu");
const [brandName, setBrandName] = useState("");


  const [roomSize, setRoomSize] = useState("");
  const [calculatedTon, setCalculatedTon] = useState("");
  const [interest, setInterest] = useState("");
  const [roomShape, setRoomShape] = useState("");
 const [courseType, setCourseType] = useState("");
const [isSubmitted, setIsSubmitted] = useState(false);

  const [fullName, setFullName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [qualification, setQualification] = useState("");
  const [profession, setProfession] = useState("");
  const [message, setMessage] = useState("");
  const [brand, setBrand] = useState("");
  const [budget, setBudget] = useState("");
  const [buildingType, setBuildingType] = useState("");
  const [repairType, setRepairType] = useState("");
  const [appliance, setAppliance] = useState("");
  const [city, setCity] = useState("");
const [pincode, setPincode] = useState("");

  const openWhatsApp = (text) => {
    window.open(
      `https://wa.me/919384177714?text=${encodeURIComponent(text)}`,
      "_blank"
    );
  };

  const calculateAC = () => {
  const size = parseInt(roomSize);
  if (!size) return;

  let resultText;

  if (size <= 130) {
    resultText = "Recommended: 1 Ton AC";
  } else if (size <= 180) {
    resultText = "Recommended: 1.5 Ton AC";
  } else if (size <= 220) {
    resultText = "Recommended: 2 Ton AC";
  } else if (size <= 320) {
    resultText = "Recommended: 2.5 Ton AC";
  } else {
    resultText = "Customized cooling solution needed – Contact us for best recommendation.";
  }

  setCalculatedTon(resultText);
  setRoomShape(size <= 200 ? "square" : "rect");
};




  /* ---------- SUBMIT HANDLERS ---------- */
 const handleStudentSubmit = (e) => {
  e.preventDefault();
  setIsSubmitted(true);

  openWhatsApp(
    `Student Admission:
Name: ${fullName}
Phone: ${phone}
Email: ${email}
Qualification: ${qualification}
Interest: ${courseType || "Not selected"}`
  );
};


  const handleCustomerSubmit = (e) => {
    e.preventDefault();
    openWhatsApp(
      `AC Site Visit:
Name: ${fullName}
Phone: ${phone}
Room Size: ${roomSize}
Brand: ${brand}
Budget: ${budget}
Building: ${buildingType}
Message: ${message}`
    );
  };

  const handleRepairSubmit = (e) => {
  e.preventDefault();
  openWhatsApp(
    `AC Repair:
Name: ${fullName}
Phone: ${phone}
Brand: ${brandName}
Issue: ${repairType}
Appliance: ${appliance}
Message: ${message}`
  );
};


  const handleEngineerSubmit = (e) => {
    e.preventDefault();
    openWhatsApp(
      `Engineer Partnership:
Name: ${fullName}
Email: ${email}
Phone: ${phone}
Company: ${qualification}
Profession: ${profession}`
    );
  };

  return (
    <div className="main-container">

      {/* ================= STUDENT ================= */}
     
{userType === "student" && (
  <>
    <h1>AC & HVAC Training – Student Zone</h1>
    <p>Practical, industry-ready programs with govt certification</p>

    <section className="details">
      <h2>🎓 Course Details</h2>

      <div className="course-box">
        <h3>1-Year Training Program</h3><br />
        <p><strong>Specialization:</strong> Air Conditioning & HVAC</p>
        <p><strong>Certificate:</strong> TNSCVT – Govt of Tamil Nadu</p>
        <p>
          <strong>Who can apply:</strong> 8th / SSLC / 12th / Diploma / ITI
        </p>
        {/* PDF Prompt and Download Link */}
        <p>Do you want the syllabus PDF? <a href={oneYearSyllabus} download="1-Year-Training-Program-Syllabus.pdf">Click here to download</a></p>
      </div>
      <br />

      {/* 3-Month Internship */}
      <div className="course-box">
        <h3>3-Month Industry Oriented Internship</h3><br />
        <p><strong>Focus:</strong> Real-time industry training</p>
        <p>
          <strong>Who can apply:</strong> Engineering Graduates
        </p>
        {/* PDF Prompt and Download Link */}
        <p>Do you want the syllabus PDF? <a href={threeMonthSyllabus} download="3-Month-Internship-Syllabus.pdf">Click here to download</a></p>
      </div>
    
    </section>

    <section className="form-section">
      <h2>Admission Form</h2>

      <form className="form-grid" onSubmit={handleStudentSubmit}>
        <input placeholder="Full Name" required onChange={e => setFullName(e.target.value)} />
        <input placeholder="Phone Number" required onChange={e => setPhone(e.target.value)} />
        <input placeholder="Email" onChange={e => setEmail(e.target.value)} />
        <input placeholder="Qualification" onChange={e => setQualification(e.target.value)} />
        <textarea placeholder="Message" onChange={e => setMessage(e.target.value)} />

        {/* ✅ Optional Course Selection */}
        <select onChange={(e) => setCourseType(e.target.value)}>
          <option value="">Select Program (Optional)</option>
          <option value="1-year">1-Year Training Program</option>
          <option value="3-month">3-Month Industry Internship</option>
        </select>

        {/* ✅ Download only AFTER submit */}
        {isSubmitted && courseType && (
          <div className="optional-syllabus">
            {courseType === "1-year" && (
              <a href={oneYearSyllabus} download target="_blank" rel="noopener noreferrer">
                Download 1-Year Program Syllabus
              </a>
            )}

            {courseType === "3-month" && (
              <a href={threeMonthSyllabus} download target="_blank" rel="noopener noreferrer">
                Download 3-Month Internship Syllabus
              </a>
            )}
          </div>
        )}

        <button className="btn-orange">Submit Form</button>

        <button type="button" className="btn-outline" onClick={() => navigate(-1)}>
          ⬅ Back
        </button>
      </form>
    </section>
  </>
)}



      {/* ================= CUSTOMER ================= */}
      {userType === "customer" && (
        <>
          {customerPage === "menu" && (
  <div className="customer-menu">
    <h1>How can we help you?</h1>

    <button
      className="btn-orange"
      onClick={() => setCustomerPage("residential")}
    >
      Residential
    </button>
    <button className="btn-outline" onClick={() => setCustomerPage("commercial")} > Commercial </button>

   


    <button
      type="button"
      className="btn-outline"
      onClick={() => navigate(-1)}
    >
      ⬅ Back
    </button>
    <div className="customer-info">
          <h2>Residential</h2><br />
          <ul>
            <li>
              Professional installation of split, window, and duct AC systems for homes, ensuring optimal cooling in every room.
            </li>
            <li>
              Regular maintenance and servicing of residential AC units to enhance efficiency and extend the lifespan of your system.
            </li>
            <li>
              Energy-efficient solutions for home air conditioning that reduce electricity bills while keeping your living space comfortable year-round.
            </li>
            <li>
              Emergency repair services for all types of residential air conditioners to restore cooling quickly without causing disruption.
            </li>
          </ul>

          <h2>Commercial</h2><br />
          <ul>
            <li>
              Customized installation of AC systems for offices, shops, and large commercial buildings to meet specific business requirements.
            </li>
            <li>
              Tailored HVAC solutions for commercial spaces designed to ensure consistent cooling and optimal indoor air quality at all times.
            </li>
            <li>
              Scheduled preventive maintenance and servicing of commercial AC units to avoid unexpected breakdowns and maintain efficiency.
            </li>
            <li>
              24/7 repair support for commercial air conditioners to minimize downtime and ensure smooth business operations without interruption.
            </li>
          </ul>
        </div>
  </div>
)}

        
         {customerPage === "residential" && (
  <div className="customer-menu">
    <h1>How can we help you?</h1>

    <button
      className="btn-orange"
      onClick={() => setCustomerPage("newac")}
    >
      New AC
    </button>

    <button
      className="btn-outline"
      onClick={() => setCustomerPage("repair")}
    >
      Repair & Service
    </button>

    <button
      type="button"
      className="btn-outline"
      onClick={() => setCustomerPage("menu")}
    >
      ⬅ Back
    </button>
    <div className="customer-info">
      {/* New AC Section */}
      <h2>New AC Installation</h2>
          <br />
      <ul>
        <li>Professional installation of new air conditioning units in homes ensuring proper placement and optimal cooling performance.</li>
        <li>Energy-efficient models designed to lower electricity bills while keeping your entire home comfortable throughout the year.</li>
        <li>Expert guidance to select the right AC model based on room size, cooling requirements, and budget considerations.</li>
        <li>Safe and timely installation with minimal disruption to your daily routine and complete quality assurance.</li>
      </ul>

      {/* Repair & Service Section */}
      <h2>Repair & Maintenance Services</h2>
      <br />
      <ul>
        <li>Comprehensive servicing and repair for all types of residential ACs including split, window, and duct models.</li>
        <li>Preventive maintenance to ensure efficiency, avoid breakdowns, and prolong the life of your air conditioning system.</li>
        <li>Emergency repair services to quickly restore cooling and provide comfort during extreme weather conditions.</li>
        <li>Use of genuine spare parts and trained technicians to guarantee long-lasting results and reliable performance.</li>
      </ul>
    </div>
  </div>
)}


          {/* -------- NEW AC -------- */}
          {customerPage === "newac" && (
            <>
              <h1 style={{textAlign:"center"}}>AC Recommendation Tool</h1>
              <p style={{textAlign:"center"}}>Enter your preferences to get personalized AC suggestions</p>

              <section className="details">
                <h2>✏️ AC Capacity Calculator</h2>
                <input
                  placeholder="Enter room size (sq ft)"
                  onChange={e => setRoomSize(e.target.value)}
                />
                <button className="btn-gray" onClick={calculateAC}>Calculate</button>

                {calculatedTon && (
  <div className="result-center">
    <p className="ton-text">{calculatedTon}</p>

    <div className="room-layouts">
      {/* Square Room */}
      <div className="room-card">
        <img src={acImage} alt="Square Room" />
        <p><strong>Square Room</strong></p>
        <p>👉 Any wall is fine</p>
      </div>

      {/* Rectangle Room */}
      <div className="room-card">
        <img src={rectImage} alt="Rectangle Room" />
        <p><strong>Rectangular Room</strong></p>
        <p>👉 Install AC on the short wall</p>
        <p>👉 Airflow should go along the long side</p>
      </div>

      
    </div>
    <section id="recommand">
  <h3>Recommended for you</h3>
<br></br>
  <div className="recommend-room-cards">
    <div className="room-card">
      <img src={onec} alt="1 way cassette ac" />
      <p><strong>1-way Cassette AC</strong></p>
      <p>
        A one-way cassette AC is a ceiling-mounted unit that delivers quiet,
        uniform cooling in one direction while saving wall space.
      </p>
    </div>

    <div className="room-card">
      <img src={fourc} alt="4 way cassette AC" />
      <p><strong>4 way cassette AC</strong></p>
      <p>
        A 4-way cassette AC is installed in the ceiling and blows cool air in four directions. It gives even cooling and is best for large rooms, offices, halls, and showrooms.
      </p>
    </div>

    <div className="room-card">
      <img src={ducttype} alt="Ductable AC" />
      <p><strong>Ductable AC</strong></p>
      <p>
        A ductable AC is a hidden system that supplies cool air through ducts to multiple rooms. It is perfect for large commercial spaces like malls, hotels, and auditoriums.
      </p>
    </div>

    <div className="room-card">
      <img src={recommand1} alt="Rectangular Room" />
      <p><strong>2-Way Cassette AC</strong></p>
      <p>
        A 2-way cassette AC cools air in two opposite directions. It is suitable for long rooms, corridors, and narrow office spaces
      </p>
    </div>

    <div className="room-card">
      <img src={degree} alt="Ductable AC" />
      <p><strong>360° Cassette AC</strong></p>
      <p>
        A 360-degree cassette AC spreads cool air in all directions evenly. It provides uniform cooling without strong air flow and is ideal for premium offices, hotels, and conference rooms.</p>
    </div>

    <div className="room-card">
      <img src={recommand2} alt="Rectangular Room" />
      <p><strong>High Wall / High Ceiling AC</strong></p>
      <p>
        This AC is mounted on walls or designed for high ceilings and large open areas. It delivers powerful airflow and is suitable for warehouses, factories, halls, and large showrooms.
      </p>
    </div>
  </div>
</section>
  </div>
)}

              </section>
              


              <section className="form-section">
                <h2>📩 Book Free Site Visit</h2>
                <form className="form-grid" onSubmit={handleCustomerSubmit}>
                  <input placeholder="Full Name" required onChange={e => setFullName(e.target.value)} />
                  <input placeholder="Phone Number" required onChange={e => setPhone(e.target.value)} />
                  <input placeholder="Room Size (sq ft)" onChange={e => setRoomSize(e.target.value)} />
                  <input placeholder="Preferred AC Brand" onChange={e => setBrand(e.target.value)} />
                  <input placeholder="Budget Range" onChange={e => setBudget(e.target.value)} />
                  <input placeholder="Building Type" onChange={e => setBuildingType(e.target.value)} />
                  <textarea placeholder="Message" onChange={e => setMessage(e.target.value)} />
                    <input
  placeholder="City"
  required
  onChange={e => setCity(e.target.value)}
/>

<input
  placeholder="Pincode"
  required
  maxLength="6"
  onChange={e => setPincode(e.target.value)}
/>
                  <button className="btn-orange">Submit Request</button>
                  <button
  type="button"
  className="btn-outline"
  onClick={() => setCustomerPage("menu")}
>
  ⬅ Back
</button>
                </form>
              </section>
            </>
          )}

          {/* -------- REPAIR -------- */}
          {customerPage === "repair" && (
            <>
              <h1>AC Repair & Service</h1>

              <section className="form-section">
                <form className="form-grid" onSubmit={handleRepairSubmit}>
                  <select onChange={e => setRepairType(e.target.value)} required>
  <option value="">Select Issue</option>
  <option value="General Checkup">General Checkup</option>
  <option value="Cooling Issue">Cooling Issue</option>
  <option value="Gas Leak">Gas Leak</option>
  <option value="Water Leakage">Water Leakage</option>
  <option value="AC Not Working">AC Not Working</option>
</select>

                  {/* <select onChange={e => setAppliance(e.target.value)}>
                    <option value="">Select Appliance</option>
                    <option>Split AC</option>
                    <option>Window AC</option>
                    <option>Central AC</option>
                  </select> */}

                  <input placeholder="Full Name" required onChange={e => setFullName(e.target.value)} />
                  <input placeholder="Phone Number" required onChange={e => setPhone(e.target.value)} />
                  <input
  placeholder="AC Brand Name (e.g., LG, Samsung)"
  required
  onChange={e => setBrandName(e.target.value)}
/>
                  <textarea placeholder="Message" onChange={e => setMessage(e.target.value)} />
                    <input
  placeholder="City"
  required
  onChange={e => setCity(e.target.value)}
/>

<input
  placeholder="Pincode"
  required
  maxLength="6"
  onChange={e => setPincode(e.target.value)}
/>
                  <button className="btn-orange">Book Service</button>
                  <button
  type="button"
  className="btn-outline"
  onClick={() => setCustomerPage("menu")}
>
  ⬅ Back
</button>
                </form>
              </section>
            </>
          )}
        </>
      )}

       {customerPage === "commercial" && (
  <section className="commercial-section">
    <h1 style={{textAlign:"center"}}>Commercial AC Solutions</h1>
    <p style={{textAlign:"center"}}>Specialized cooling solutions for different commercial spaces</p>

    <div className="commercial-cards">
      <div className="commercial-card">
        <img src={hospital} alt="Hospital AC Solutions" />
        <h3>Hospital AC Solutions</h3>
        <p>
          Provides clean, quiet, and stable cooling with proper air circulation
          to maintain hygiene and patient comfort.
        </p>
      </div>

      <div className="commercial-card">
        <img src={mall} alt="Mall AC Solutions" />
        <h3>Mall AC Solutions</h3>
        <p>
          Delivers powerful cooling for large open areas with uniform airflow
          to keep shoppers comfortable.
        </p>
      </div>

      <div className="commercial-card">
        <img src={restaurant} alt="Restaurant AC Solutions" />
        <h3>Restaurant AC Solutions</h3>
        <p>
          Ensures fresh air circulation, odor control, and comfortable
          temperature for dining areas and kitchens.
        </p>
      </div>

      <div className="commercial-card">
        <img src={hotel} alt="Hotel AC Solutions" />
        <h3>Hotel AC Solutions</h3>
        <p>
          Offers silent operation, energy-efficient cooling, and individual
          room temperature control for guest comfort.
        </p>
      </div>

      <div className="commercial-card">
        <img src={threater} alt="Theatre AC Solutions" />
        <h3>Theatre AC Solutions</h3>
        <p>
          Provides silent and powerful cooling with even air distribution
          to ensure audience comfort without noise disturbance.
        </p>
      </div>
    </div><br></br>
    <button
  type="button"
  className="btn-outline"
  onClick={() => setCustomerPage("menu")}
>
  ⬅ Back
</button>
  </section>
)}

      {/* ================= ENGINEER ================= */}
      {userType === "engineer" && (
        <>
          <h1>Engineer Technical Portal</h1>
          <p>Access technical resources and partner opportunities</p>

          <section className="details" id="engineer-details">
            <h2>Duct Design & Production</h2>
            <ul>
              <li>Spiral, Rectangular, Flat, L-Shape</li>
              <li>CAD Drawings & BOQ</li>
              <li>Tools & Machinery</li>
              <li>Project Portfolio</li>
            </ul>
          </section>

          <section className="details" id="engineer-details">
            <h2>Service Support</h2>
            <ul>
              <li>AMC & Breakdown Support</li>
              <li>Installation</li>
              <li>Troubleshooting</li>
              <li>Copper Pipeline works</li>
            </ul>
          </section>

          <section className="form-section">
            <h2>🤝 Partner With Us</h2>
            <form className="form-grid" onSubmit={handleEngineerSubmit}>
  <input
    placeholder="Full Name"
    required
    onChange={e => setFullName(e.target.value)}
  />

  <input
    placeholder="Phone Number"
    required
    onChange={e => setPhone(e.target.value)}
  />

  <input
    placeholder="Email ID"
    required
    onChange={e => setEmail(e.target.value)}
  />

  <input
    placeholder="Company Name"
    onChange={e => setQualification(e.target.value)}
  />

  {/* I am a dropdown */}
  <select required onChange={e => setProfession(e.target.value)}>
    <option value="">choose Your Profession</option>
    <option>Architect</option>
    <option>Builder</option>
    <option>Civil Engineer</option>
    <option>Interior Designer</option>
    <option>Electrical Contractor</option>
    <option>Dealer</option>
    <option>Other</option>
  </select>

  <button className="btn-orange">Submit Details</button>

  <button
    type="button"
    className="btn-outline"
    onClick={() => navigate(-1)}
  >
    ⬅ Back
  </button>
</form>

          </section>
        </>
      )}
    </div>
  );
}
